import React, { useState, useEffect } from "react";
import Fuse from "fuse.js";

import { SearchBar } from "jobin-ui-components";
import FilterCustom from "./FilterCustom";

const fuseOptions = {
    shouldSort: true,
    threshold: 0.6,
    location: 0,
    distance: 100,
    maxPatternLength: 32,
    minMatchCharLength: 1,
    keys: ["name"]
};

export default function FilterSingleSelection(props) {
    const [loading, setLoading] = useState(true);
    const [selection, setSelection] = useState(props.prevSelection);
    const [query, setQuery] = useState("");
    const [filtered, setFiltered] = useState(false);
    const [items, setItems] = useState(props.items);
    const [title, setTitle] = useState("");

    useEffect(() => {
    
        if(props.title){
            setTitle(props.title)
        }
    
    });
    useEffect(() => {
        if (selection) {
            optionSelected(selection);
        }
        if(props.title){
            setTitle(props.title)
        }
        const selected = items.filter(item => item.selected);
        setFiltered(selected.length > 0);
        setLoading(false);
    }, []);

    const optionSelected = item => {
        if (loading || item !== selection) {
            setItems(prevItems => {
                return prevItems.map((prevItem, idx) => {
                    if (prevItem.id === item.id) {
                        const newItem = {
                            ...prevItems[idx],
                            selected: true
                        };
                        setSelection(newItem);
                        setFiltered(true);
                        if(props.itemData != null){
                            props.selectionChange(newItem,props.itemData,props.type);
                        }else{
                            props.selectionChange(newItem);
                        }
                        return newItem;
                    } else {
                        return {
                            ...prevItems[idx],
                            selected: false
                        };
                    }
                });
            });
        }else{
            setItems(prevItems => {
                return prevItems.map((prevItem, idx) => {
                    if (prevItem.id === item.id) {
                        const newItem = {
                            ...prevItems[idx],
                            selected: false
                        };
                        setSelection([]);
                        setFiltered(true);
                        if(props.itemData != null){
                            props.selectionChange([],props.itemData,props.type);
                        }else{
                            props.selectionChange([]);
                        }
                        return newItem;
                    } else {
                        return {
                            ...prevItems[idx],
                            selected: false
                        };
                    }
                });
            });
        }
    };

    const renderMenu = () => {
        const fuse = new Fuse(items, fuseOptions);
        const data = query ? fuse.search(query) : items;
        return (
            <div className="items-filter">
                <SearchBar
                    style={{ height: 36, width: 180 }}
                    styleinput={{ height: 36 }}
                    placeholder={"Filtrar"}
                    onChange={e => setQuery(e.target.value)}
                />
                <div className="options">
                    <ul>
                        {data.map(item => {
                            return (
                                <li key={`${item.name}-${item.id}`}>
                                    <label htmlFor={item.id}>
                                        <input
                                            id={item.id}
                                            type="checkbox"
                                            className="native-hidden"
                                            onChange={() =>
                                                optionSelected(item)
                                            }
                                        />
                                        <svg
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                        >
                                            <g fill="none" fillRule="evenodd">
                                                <path d="M0 0h24v24H0z" />
                                                {item.selected ? (
                                                    <React.Fragment>
                                                        <rect
                                                            width="22"
                                                            height="22"
                                                            x="1"
                                                            y="1"
                                                            fill="#2543FF"
                                                            rx="2"
                                                        />
                                                        <path
                                                            fill="#FFF"
                                                            d="M9.615 14.279L7.742 12.36a1.002 1.002 0 0 0-1.443 0 1.06 1.06 0 0 0 0 1.477l2.594 2.656a1.002 1.002 0 0 0 1.443 0l6.165-6.311a1.06 1.06 0 0 0 0-1.477 1.002 1.002 0 0 0-1.443 0L9.615 14.28z"
                                                        />
                                                    </React.Fragment>
                                                ) : (
                                                    <rect
                                                        width="21"
                                                        height="21"
                                                        x="1.5"
                                                        y="1.5"
                                                        stroke="#444444"
                                                        rx="2"
                                                    />
                                                )}
                                            </g>
                                        </svg>
                                        <span>{item.name}</span>
                                    </label>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            </div>
        );
    };

    return (
        <FilterCustom
            idElement={props.idElement}
            style={props.style}
            styleButton={props.styleButton}
            styleMenu={props.styleMenu}
            type={props.type}
            title={title}
            filtered={filtered}
            menu={renderMenu()}
            right={props.right ? props.right : false}
            disabled={props.disabled}
        />
    );
}
